import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import OpenPaidMeetingPrice from './OpenPaidMeetingPrice';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PaidMeetingPrice = props => {
  const {
    currency,
    price,
    paid
  } = props;
  const currencyAndAmount = /*#__PURE__*/_jsx(FormattedIntlCurrency, {
    value: price,
    currencyCode: currency
  });
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "200",
    as: "div",
    children: [/*#__PURE__*/_jsx(H5, {
      "data-selenium": "paid-meeting-price",
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'payments.priceHeader',
        options: {
          price: price === 0 ? /*#__PURE__*/_jsx(OpenPaidMeetingPrice, {
            currency: currency
          }) : currencyAndAmount
        }
      })
    }), /*#__PURE__*/_jsx(Small, {
      "data-selenium": `paid-meeting-price-subtitle-${paid ? 'paid' : 'unpaid'}`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: paid ? 'payments.paidSubheader' : 'payments.unpaidSubheader'
      })
    })]
  });
};
export default PaidMeetingPrice;